import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

export interface ExpenseFilters {
    zone_id?: number | string;
    designation_id?: number | string;
    employee_id?: number | string;
    from_date?: string;
    to_date?: string;
}

function buildParams(filters: ExpenseFilters): string {
    const p = new URLSearchParams();
    if (filters.zone_id)        p.append("zone_id",        String(filters.zone_id));
    if (filters.designation_id) p.append("designation_id", String(filters.designation_id));
    if (filters.employee_id)    p.append("employee_id",    String(filters.employee_id));
    if (filters.from_date)      p.append("from_date",      filters.from_date);
    if (filters.to_date)        p.append("to_date",        filters.to_date);
    const qs = p.toString();
    return qs ? `?${qs}` : "";
}

export const getExpenseSummary = (tenantId: number | string, filters: ExpenseFilters = {}) =>
    api.get(`${API_ROUTES.EXPENSE}/summary/${tenantId}${buildParams(filters)}`);

export const getEmployeeExpenseDetail = (
    tenantId: number | string,
    employeeId: number | string,
    filters: Pick<ExpenseFilters, "from_date" | "to_date"> = {}
) =>
    api.get(`${API_ROUTES.EXPENSE}/employee/${tenantId}/${employeeId}${buildParams(filters)}`);

/** Fetches the CSV as a Blob and triggers a browser download. */
export const downloadExpenseCSV = async (
    tenantId: number | string,
    filters: ExpenseFilters = {}
): Promise<void> => {
    const response = await api.get(
        `${API_ROUTES.EXPENSE}/export/${tenantId}${buildParams(filters)}`,
        { responseType: "blob" }
    );
    const url  = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
    const link = document.createElement("a");
    link.href  = url;
    link.setAttribute("download", `expenses_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};
